import type { PopupRequest } from '@azure/msal-browser';

declare global {
  interface Window {
    __ORR_TOKENS__?: Record<string, string>;
  }
}

const normalizeAudience = (audience: string) =>
  audience.replace(/^api:\/\//i, '').toLowerCase();

const getInjectedTokens = () => {
  if (typeof window === 'undefined') return null;
  return window.__ORR_TOKENS__ ?? null;
};

export const hasAuthTokens = () => {
  const tokens = getInjectedTokens();
  return !!tokens && Object.values(tokens).some(Boolean);
};

export const getAuthToken = (request: PopupRequest): string | null => {
  const tokens = getInjectedTokens();
  if (!tokens) return null;

  for (const scope of request.scopes ?? []) {
    const match = scope.match(/^api:\/\/([^/]+)\//i);
    if (!match) continue;

    const requestedAudience = normalizeAudience(match[1]);
    const token = Object.entries(tokens).find(
      ([audience, value]) =>
        value && normalizeAudience(audience) === requestedAudience,
    )?.[1];

    if (token) return token;
  }

  return null;
};
